export const selectCustomStyle = {
  control: (base, state) => ({
    ...base,
    background: '#ffffff',
    color: '#3d3929',
    borderRadius: state.isFocused ? '3px 3px 0 0' : 3,
    borderColor: state.isFocused ? '#da7756' : '#c8c4b6',
    boxShadow: state.isFocused ? null : null,
    '&:hover': {
      borderColor: '#da7756',
    },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 0,
    marginTop: 0,
    backgroundColor: '#ffffff',
    color: '#3d3929',
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    backgroundColor: '#ffffff',
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: '#8b7e6a',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#3d3929',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#da7756' : state.isFocused ? '#f5f3ea' : '#ffffff',
    color: state.isSelected ? '#ffffff' : '#3d3929',
    '&:active': {
      backgroundColor: '#bd5d3a',
    },
  }),
};
